import React, { useState } from 'react';
import { forgotPassword } from '../services/api';
import { useLang } from '../context/LanguageContext';

export default function ForgotPasswordModal({ onClose }) {
  const [email, setEmail]     = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError]     = useState('');

  const { t } = useLang();
  const fm = t.forgotModal;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      await forgotPassword(email);
      setSuccess(true);
    } catch {
      setError(fm.genericError);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 px-4" onClick={onClose}>
      <div className="w-full max-w-sm bg-white rounded-2xl p-6 shadow-xl" onClick={(e) => e.stopPropagation()}>
        <h2 className="text-lg font-bold text-slate-900 mb-1">{fm.title}</h2>

        {success ? (
          <>
            <p className="text-sm text-slate-600 mt-2 mb-5">
              {fm.successBefore}<strong>{email}</strong>{fm.successAfter}
            </p>
            <button onClick={onClose} className="w-full btn-primary justify-center">{fm.gotIt}</button>
          </>
        ) : (
          <>
            <p className="text-sm text-slate-500 mb-4">{fm.subtitle}</p>
            <form onSubmit={handleSubmit} className="space-y-3">
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder={fm.emailPlaceholder}
                required
                className="w-full border border-slate-300 rounded-lg px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-primary-500"
              />
              {error && <p className="text-sm text-red-500">{error}</p>}
              <div className="flex gap-2 pt-1">
                <button
                  type="button"
                  onClick={onClose}
                  className="flex-1 py-3 rounded-lg border-2 border-slate-200 text-sm font-semibold text-slate-500 hover:border-slate-400 transition-colors"
                >
                  {fm.cancel}
                </button>
                <button
                  type="submit"
                  disabled={loading}
                  className="flex-1 btn-primary justify-center disabled:opacity-50"
                >
                  {loading ? fm.sending : fm.send}
                </button>
              </div>
            </form>
          </>
        )}
      </div>
    </div>
  );
}
